<template>
  <div class="jin-pc-breadcrumb">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(item, i) in breadcrumb" :key="item.name + i" :to="item.url ? { path: item.url } : ''">{{ item.name }}</el-breadcrumb-item>
    </el-breadcrumb>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      // breadcrumb: [{
      //   name: '职位类别',
      //   url: '/list'
      // }]
    }
  },
  computed: {
    ...mapGetters([
      'details'
    ]),
    breadcrumb() {
      const { title, category_id, id, attributes, category_name } = this.$route.query
      const breadcrumb = [
        {
          name: '职位类别',
          url: `/list?attributes=${attributes}`
        }, {
          name: title,
          url: `/list?title=${title}&category_id=${title === '全部职位' ? '' : category_id}&attributes=${attributes}`
        }, {
          name: category_name || (this.details ? this.details.name : ''),
          url: ''
        }
      ]
      if (this.$route.path.includes('resume')) {
        breadcrumb[2].url = `/list/info?id=${id}&title=${title}&category_id=${category_id}&attributes=${attributes}`
        breadcrumb.push(
          {
            name: '编辑简历'
          }
        )
      }
      return breadcrumb
    }

  }
}
</script>

<style lang="scss" scoped>
.jin-pc-breadcrumb {
  padding: 30px 40px;

  /deep/ .el-breadcrumb__item {
    i {
      color: #b4b7c5;
    }

    .el-breadcrumb__inner {
      font-size: 14px;
      font-weight: 500;
      color: #787b8a;
      line-height: 20px;
    }

    .el-breadcrumb__inner.is-link {
      color: #4777f4;
    }
  }
}
</style>
